import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import getHistory from 'globalHistory';
import { pills as Pills } from '@breezeway/brzw-components';
import StatusPill from '@common/components/status_pill';
import DefaultSkeleton from '../../skeletons/default_skeleton';

import './ready_status_cell.scss';

const { PILL_THEMES } = Pills.constants;

const CLASS_NAME = 'ready-status-cell';

const ReadyStatusCell = (props, customProps) => {
  const readyStatus = _.get(props, 'type_property_ready_status');
  const propertyId = _.get(props, 'home_id');
  const readyStatusCode = _.get(readyStatus, 'code');
  const readyStatusName = _.get(readyStatus, 'name');
  const withLink = _.get(customProps, 'withLink');
  const withIcon = _.get(customProps, 'withIcon');
  const shouldShowEmptyState = _.get(customProps, 'shouldShowEmptyState');

  if (_.get(customProps, 'withSkeletons') && _.isUndefined(readyStatus)) {
    return <DefaultSkeleton />;
  }

  if (_.isEmpty(_.keys(readyStatus)) || shouldShowEmptyState) {
    return <div className="default-cell--empty"> - </div>;
  }

  if (withLink) {
    const goToProperty = () =>
      getHistory().push({
        pathname: `/property/${propertyId}/about`,
      });

    return (
      <div className={`${CLASS_NAME}--link`} role="presentation" onClick={goToProperty}>
        <StatusPill
          code={readyStatusCode}
          name={readyStatusName}
          onClick={goToProperty}
          theme={PILL_THEMES.FOURTH}
          withIcon={withIcon}
        />
      </div>
    );
  }

  return (
    <StatusPill readOnly code={readyStatusCode} name={readyStatusName} theme={PILL_THEMES.FOURTH} />
  );
};

ReadyStatusCell.propTypes = {
  type_property_ready_status: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default ReadyStatusCell;
